/**
 * Casa Platino — Master Color Map
 * Maps product color names to hex values for swatch display.
 * Normalized (lowercase, trimmed) for lookup.
 */
window.CP_COLORS = {
  // --- Primary brand colors ---
  "pearl":              "#F6F3F0",
  "teal":               "#2F6D80",
  "terra cotta":        "#D1A179",
  "midnight":           "#435861",

  // --- Neutrals ---
  "white":              "#FAFAF7",
  "ivory":              "#F0E9DC",
  "vanilla":            "#F4EBD3",
  "linen":              "#E8DCC6",
  "beige":              "#D6C5A8",
  "taupe":              "#A89B8C",
  "mineral":            "#9BA39E",
  "silver":             "#C8CCD0",
  "platinum":           "#BDC0C4",
  "cool grey":          "#A5ABB0",
  "grey":               "#888D92",
  "paloma grey":        "#9FA3A6",
  "glacier grey":       "#BFC7CD",
  "ultimate grey":      "#7A7E83",
  "charcoal":           "#4A4E54",
  "black":              "#1A1A1A",

  // --- Blues ---
  "ballad blue":        "#8FA8C4",
  "sky blue":           "#A8C8DC",
  "light blue":         "#B6CEE0",
  "aqua":               "#7EB9C4",
  "aqua sky":           "#A8D0DB",
  "cerulean blue":      "#3D6E93",
  "cool blue":          "#6B94B8",
  "cornflower":         "#6A8EC2",
  "blue":               "#3E6E9C",
  "sand blue":          "#8FA5B5",
  "steel blue":         "#536F82",
  "french blue":        "#5B7A93",
  "estate blue":        "#3A5772",
  "dark denim":         "#3F4E63",
  "denim":              "#4E6478",
  "navy":               "#1F2F4A",
  "indigo":             "#253559",
  "nautical":           "#2D4560",
  "ocean breeze":       "#7FA8B5",

  // --- Greens ---
  "sage":               "#A8B098",
  "olive":              "#7A7B52",
  "olive green":        "#6E7545",
  "hunter green":       "#2E4E38",
  "buffalo green":      "#3D5E4A",
  "oil green":          "#4A5442",
  "green":              "#5E7A55",
  "ice berg green":     "#B8CEC1",
  "icebery green":      "#B8CEC1",

  // --- Reds / Pinks ---
  "red":                "#B13839",
  "christmas red":      "#A82A2A",
  "buffalo red":        "#8E2E30",
  "rust":               "#A85A3A",
  "rust red":           "#9E4532",
  "windsor wine":       "#6D2830",
  "canyon rose":        "#C88F80",
  "cashmere rose":      "#C89B96",
  "sepia rose":         "#B08477",
  "rose dawn":          "#D4A8A0",
  "old glory pink":     "#D49BA2",
  "peach fuzz":         "#E8B09A",

  // --- Browns ---
  "brown":              "#6B4F3B",
  "towny brown":        "#7E5A42",
  "cocoon":             "#8C7760",

  // --- Yellows ---
  "yellow":             "#DDB940",

  // --- Purples ---
  "lilac":              "#B5A3C4",
  "tropica":            "#A28AB8",

  // --- Teals ---
  "teal":               "#2F6D80",
  "old glory teal":     "#3A6D7A",

  // --- Special / Multi ---
  "allure":             "#A59B88",
  "moonstruck":         "#E3DED3",
  "old glory":          "#7D8A99",
  "polka dot black":    "#1A1A1A",
  "polka dot blue":     "#3E6E9C",
  "polka dot":          "#EEE8DF",
  "chevron-cool blue":  "#6B94B8",
  "trellis-silver":     "#C8CCD0",
  "grey stripe":        "#B8B6B1",
  "blue stripe":        "#5E7A93",
  "white stripe":       "#EFE9DF",
  "ticking stripe silver":      "#C8CCD0",
  "ticking stripe-blue":        "#5E7A93",
  "ticking stripe-cobalt blue": "#3D5772",
  "blue chambray":      "#6B7F95",
  "grey chambray":      "#989B9E",
  "red check":          "#A04040",
  "red plaid":          "#8E3030",
  "white plaid":        "#EFE8DB",
  "whie plaid":         "#EFE8DB",
  "window pane":        "#B8B6B1",
  "windowpane-charcoal": "#4A4E54",
  "misty dot":          "#D8D6D0",
  "grey-white dot":     "#BCB8B1",
  "white base grey dot": "#EADED3",
  "white-grey dot":     "#E5E2DC",
  "coral beach":        "#D49088",
  "blue white":         "#B5C9D5",
  "stripe silver":      "#C0C3C6",
  "stripe blue":        "#5E7A93",
  "stripe cobalt blue": "#3D5772",

  // --- Aliases for catalog typos & dash/space variants ---
  // (any variant that doesn't auto-resolve via the matcher below)
  "navy blue":                 "#1F2F4A",
  "vanila":                    "#F4EBD3",  // typo of vanilla
  "charcol":                   "#4A4E54",  // typo of charcoal
  "rose down":                 "#D4A8A0",  // typo of rose dawn
  "windowpane":                "#B8B6B1",
  "window pane-charcoal":      "#4A4E54",
  "polka dot-black":           "#1A1A1A",
  "ticking stripe blue":       "#5E7A93",
  "white base dot-silver":     "#EADED3",
  "ticking stripe cobalt blue":"#3D5772",  // alias for stripe cobalt blue
  "grey white dot":            "#BCB8B1",  // alias for grey-white dot
  "white grey dot":            "#E5E2DC",  // alias for white-grey dot
  "platinum grey":             "#BDC0C4",  // alias for platinum
  "aqua blue":                 "#7EB9C4",  // alias for aqua

  // --- Genuinely new colors (chambray family + emerald) ---
  "emerald":                   "#1F7A4A",
  "indigo chambray":           "#4A5772",
  "olive chambray":            "#6E7548",
  "red chambray":              "#A04550"
};

/**
 * Look up the hex code for a color name.
 * Tries the normalized key first, then dash/space variants, so
 * "Ticking Stripe Blue" (raw space) finds "ticking stripe-blue" (dash),
 * and "Windowpane" (no space) finds "window pane" (with space).
 */
window.CP_getColorHex = function(name) {
  if (!name) return "#CCCCCC";
  var raw = String(name).toLowerCase().trim()
    .replace(/\s+/g, ' ')
    .replace(/[–—]/g, '-');
  if (window.CP_COLORS[raw]) return window.CP_COLORS[raw];

  // Try common separator variants
  var candidates = [
    raw.replace(/-/g, ' ').replace(/\s+/g, ' '),  // all dashes → spaces
    raw.replace(/\s/g, '-'),                      // all spaces → dashes
    raw.replace(/[-\s]+/g, '')                    // no separators
  ];
  for (var i = 0; i < candidates.length; i++) {
    if (window.CP_COLORS[candidates[i]]) return window.CP_COLORS[candidates[i]];
  }

  return "#CCCCCC";
};
